<template>
  <div class="flex w-full max-w-[373px] flex-col rounded-[20px] bg-white-gray">
    <slot />
  </div>
</template>
